import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/shift-toward.css';

import { debounce } from '@/partials/el.Utils.js';
import { initialiseTooltips } from '@/partials/el.Tooltips.js';
import { initialiseEcologiTreeCount } from '@/partials/el.EcologiTreeCount.js';

window.elabs = window.elabs || {};
window.elabs.debounce = debounce;
window.elabs.initialiseTooltips = initialiseTooltips;

document.addEventListener('DOMContentLoaded', () => {
  initialiseTooltips();
  initialiseEcologiTreeCount();
});
